import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { emart, everyday, noBrand, traders, landers } from "../../styles";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

const useSelectBrand = () => {
  const [color, setColor] = useState();
  const [hex, setHex] = useState();
  const [text, setText] = useState();
  const brandId = useSelector((state) => state.checkArsStatus.brandId);

  const location = useLocation();
  const queryParams = queryString.parse(location.search);

  useEffect(() => {
    if (brandId === "EM") {
      setColor(emart.color);
      setHex(emart.hex);
      setText("이마트");
    } else if (brandId === "NB") {
      setColor(noBrand.color);
      setHex(noBrand.hex);
      setText("노브랜드");
    } else if (brandId === "TR") {
      setColor(traders.color);
      setHex(traders.hex);
      setText("트레이더스");
    } else if (brandId === "ED") {
      setColor(everyday.color);
      setHex(everyday.hex);
      setText("에브리데이");
    } else if (brandId === "LD") {
      setColor(landers.color);
      setHex(landers.hex);
      setText("SSG 랜더스");
    } else if (!brandId) {
      if (queryParams.brandId === "EM") {
        setColor(emart.color);
        setHex(emart.hex);
        setText("이마트");
      } else if (queryParams.brandId === "NB") {
        setColor(noBrand.color);
        setHex(noBrand.hex);
        setText("노브랜드");
      } else if (queryParams.brandId === "TR") {
        setColor(traders.color);
        setHex(traders.hex);
        setText("트레이더스");
      } else if (queryParams.brandId === "ED") {
        setColor(everyday.color);
        setHex(everyday.hex);
        setText("에브리데이");
      } else if (queryParams.brandId === "LD") {
        setColor(landers.color);
        setHex(landers.hex);
        setText("SSG 랜더스");
      }
    }
  }, [brandId]);
  return { color, text, hex };
};

export default useSelectBrand;
